var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('pre',{staticClass:"m-ace-editor",style:({
		width: /px|\%|rem/.test(_vm.width) ? _vm.width : _vm.width + 'px',
		height: /px|\%|rem/.test(_vm.height) ? _vm.height : _vm.height + 'px',
		lineHeight: _vm.lineHeight
	})})}
var staticRenderFns = []

export { render, staticRenderFns }